/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  UpdateUserSettingRequest,
  UserSettingKey,
  UserSettingResponse,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateUserSettingRequestFromJSON,
    UpdateUserSettingRequestToJSON,
    UserSettingKeyFromJSON,
    UserSettingKeyToJSON,
    UserSettingResponseFromJSON,
    UserSettingResponseToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface UpdateUserSettingOperationRequest {
    key: UserSettingKey;
    updateUserSettingRequest: UpdateUserSettingRequest;
}

/**
 * UserSettingsApi - interface
 * 
 * @export
 * @interface UserSettingsApiInterface
 */
export interface UserSettingsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApiInterface
     */
    getUserSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserSettingResponse>>>;

    /**
     */
    getUserSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserSettingResponse>>;

    /**
     * 
     * @param {UserSettingKey} key 
     * @param {UpdateUserSettingRequest} updateUserSettingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApiInterface
     */
    updateUserSettingRaw(requestParameters: UpdateUserSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSettingResponse>>;

    /**
     */
    updateUserSetting(requestParameters: UpdateUserSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSettingResponse>;

}

/**
 * 
 */
export class UserSettingsApi extends runtime.BaseAPI implements UserSettingsApiInterface {

    /**
     */
    async getUserSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserSettingResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/user-settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserSettingResponseFromJSON));
    }

    /**
     */
    async getUserSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserSettingResponse>> {
        const response = await this.getUserSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateUserSettingRaw(requestParameters: UpdateUserSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSettingResponse>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateUserSetting().'
            );
        }

        if (requestParameters['updateUserSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserSettingRequest',
                'Required parameter "updateUserSettingRequest" was null or undefined when calling updateUserSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-settings/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserSettingRequestToJSON(requestParameters['updateUserSettingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSettingResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateUserSetting(requestParameters: UpdateUserSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSettingResponse> {
        const response = await this.updateUserSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
